// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border-bottom[data-v-294c6d21] {\n  border-bottom: 1px solid #ebedf2;\n}\n.tools-buttons[data-v-294c6d21] {\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
module.exports = exports;
